const getConfig = () => {
  const conf = typeof window !== "undefined" && window.__APP_CONFIG__ ? window.__APP_CONFIG__ : {};

  const required = (v, name) => {
    if (!v) throw new Error(`Missing required config: ${name}`);
    return v;
  };

  return {
    REACT_APP_LAMBDAS_BASE_URL: required(conf.LAMBDAS_BASE_URL, "LAMBDAS_BASE_URL"),
    REACT_APP_HOME_PAGE_URL:   required(conf.HOME_PAGE_URL, "HOME_PAGE_URL"),
    REACT_APP_CLIENT_ID:       required(conf.CLIENT_ID, "CLIENT_ID"),
    REACT_APP_COGNITO_URL:     required(conf.COGNITO_URL, "COGNITO_URL"),
    REACT_APP_CSRF_COOKIE_NAME: required(conf.CSRF_COOKIE_NAME, "CSRF_COOKIE_NAME"),
  };
};

export const ENV = getConfig();